import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faUsers } from "../../../node_modules/@fortawesome/free-solid-svg-icons/index";
import '../../assets/styles/Style.css'
import axios from 'axios';
import Circles from '../../assets/images/circle.png'
 
const DashboardNature =()=>{
  const [totalSurvey, setTotalSurvey] = useState(0)
  const [todaySurvey, setTodaySurvey] = useState(0)
  const [monthSurvey, setMonthSurvey] = useState(0)
  const [yearSurvey, setYearSurvey] = useState(0)
 
  const [filterArray, setFilterArray] = useState([]);
 const [arrayCount, setArrayCount] = useState([])
const [cropCount, setCropCount] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      let yearSurveyValue = 0;
      let monthSurveyValue = 0;
      let todaySurveyValue = 0;
      let totalSurveyValue =0;
    
      const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/TranCropSurvey`);
  
    
      let formsData = result.data.dataContent;
       totalSurveyValue = formsData.length;
  
      var todayDate = new Date()
      var previousDate = new Date(todayDate);
    
      previousDate.setMonth(previousDate.getMonth() - 1);
   
        let filterData = []
        let arrayCount = []
        let cropCount = []
        // This logic is for last 1 month survey
        filterData = formsData.filter((x) => {       
          let date = new Date(x.surveyorDate.split(" ")[0].replaceAll("/", ",")); 
        
          arrayCount.push(formsData.indexOf(x))
          cropCount.push(x.cropCode)
  
  
  
          if(date.getFullYear() === todayDate.getFullYear()) {
            yearSurveyValue++
            if(date.getMonth() === todayDate.getMonth()){
            monthSurveyValue++
            if(date.getDate() === todayDate.getDate()){
              todaySurveyValue++
            }}}
          
             
          return (
            previousDate <= date &&  date <= todayDate
          )
      });
  
      // This logic is for last 10 survey
  
      filterData = formsData.slice(0, 10);

      console.log("data", filterData,monthSurveyValue, yearSurveyValue, totalSurveyValue, todaySurveyValue)
  
      setFilterArray(filterData)
      setMonthSurvey(monthSurveyValue)
      setYearSurvey(yearSurveyValue)
      setTotalSurvey(totalSurveyValue)
      setTodaySurvey(todaySurveyValue)
      setArrayCount(arrayCount)
      setCropCount(cropCount)
  
  };
  fetchData()
  }, [])
 

  
 

  return (
    <>
    
    <main id="main" className="main">

<div className="pagetitle">
  <h1>Dashboard</h1>
  <nav>
    <ol className="breadcrumb">
      <li className="breadcrumb-item">Admin</li>
      <li className="breadcrumb-item active">Dashboard</li>
    </ol>
  </nav>
</div>
<section className="section dashboard">
  <div className="row">
  
     <div className="col-xxl-3 col-md-6">
      <div className="card info-card  sales-card bg-gradient-danger card-img-holder">

        <div className="card-body">
        <img src={Circles} className="card-img-absolute" alt="circle-image"/> 
          <h5 className="card-title">Active  <span>| Today</span></h5>

          <div className="d-flex align-items-center">
            <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
            <i><FontAwesomeIcon icon={faUsers} /> </i>
            </div>
            <div className="ps-3">
              <h6>{todaySurvey}</h6>
              <span className="text-success small pt-1 fw-bold">5%</span> <span className="text-muted small pt-2 ps-1">increase</span>

            </div>
          </div>
        </div>

      </div>
    </div>
    <div className="col-xxl-3 col-md-6">
    <div className="card info-card  sales-card bg-gradient-primary card-img-holder">
    

        <div className="card-body">
        <img src={Circles} className="card-img-absolute" alt="circle-image"/> 
          <h5 className="card-title">Total  <span>|This Month</span></h5>

          <div className="d-flex align-items-center">
            <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
            <i><FontAwesomeIcon icon={faUsers} /> </i>
            </div>
            <div className="ps-3">
              <h6>{monthSurvey}</h6>
              <span className="text-success small pt-1 fw-bold">12%</span> <span className="text-muted small pt-2 ps-1">increase</span>

            </div>
          </div>
        </div>

      </div>
    </div>
    <div className="col-xxl-3 col-md-6">
    <div className="card info-card  sales-card bg-gradient-success card-img-holder">

        <div className="card-body">
        <img src={Circles} className="card-img-absolute" alt="circle-image"/> 
          <h5 className="card-title">Registered  <span>| This Year</span></h5>

          <div className="d-flex align-items-center">
            <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
            <i><FontAwesomeIcon icon={faUsers} /> </i>
            </div>
            <div className="ps-3">
              <h6>{yearSurvey}</h6>
              <span className="text-success small pt-1 fw-bold">8%</span> <span className="text-muted small pt-2 ps-1">increase</span>

            </div>
          </div>
        </div>

      </div>
    </div>
    <div className="col-xxl-3 col-xl-12">

    <div className="card info-card  sales-card bg-gradient-primary card-img-holder">


        <div className="card-body">
        <img src={Circles} className="card-img-absolute" alt="circle-image"/> 
          <h5 className="card-title">New Registered  <span>| OverAll</span></h5>

          <div className="d-flex align-items-center">
            <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
            <i><FontAwesomeIcon icon={faUsers} /> </i>
            </div>
            <div className="ps-3">
              <h6>{totalSurvey}</h6>
              <span className="text-danger small pt-1 fw-bold">12%</span> <span className="text-muted small pt-2 ps-1">decrease</span>

            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
  <div className="row">

   
    <div className="col-lg-12">
      <div className="row">
    <div className="col-12">
          <div className="card">

          <div className="card-body">
              <h5 className="card-title">Recent Crop Survey <span>| Last 10 Crop Survey</span></h5>

              <table className="table table-bordered" >
                <thead>
                  <tr>
                    <th scope="col">Farmer Name</th>
                    <th scope="col">Season Name</th>
                    <th scope="col">Crop Name</th>
                    <th scope="col">State Name</th>
                    <th scope="col">District Name</th>
                    <th scope="col">Champion Farmer Name</th>
                  </tr>
                </thead>
                <tbody>

                  { filterArray ? filterArray.map((item, index) => {
                    return  <tr key={index}>
                    <th scope="row">{item.farmerName}</th>
                    <td >{item.seasonName}</td>
                    <td>{item.cropName}</td>
                    <td>{item.stateName}</td>
                    <td>{item.districtName}</td>
                    <td>{item.championFarmerName}</td>
                  </tr>
                  }) : ''}
                 
                </tbody>
              </table>

            </div>


        
        </div>
  
       
      </div>
    </div>
  </div>
  </div>
</section>

</main>
    </>

  )
   
}
 
export default DashboardNature;